import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HoomvipStorage} from '../hoomvip-storage/hoomvip-storage.service';
import {Observable} from 'rxjs';
import {Checkin} from '../../shared/models/check-ins.model';
import {CheckInsWithChildren} from '../../shared/models/check-ins-with-children.model';
import {SetCheckInAdult} from '../../shared/models/set-check-in-adult.model';
import {SetCheckInMinor} from '../../shared/models/set-check-in-minor.model';
import {ApiConfigService} from './api.config.service';
import {HTTP_CACHE_TTL_MS, HttpCacheService} from '../services/http-cache.service';
import {map} from 'rxjs/operators';
import {CheckInStatusData, CheckInStatusResponse} from '../../shared/models/check-in-status.model';

export interface CheckInsWithChildrenResponse {
  checkins: CheckInsWithChildren;
}

@Injectable({providedIn: 'root'})
export class CheckInService {
  constructor(private http: HttpClient, private hoomvipStorage: HoomvipStorage, private apiConfigService: ApiConfigService, private cache: HttpCacheService) {
  }

  getCheckInStatus(): Observable<CheckInStatusData> {
    const code = this.hoomvipStorage.getCode();
    const url = this.apiConfigService.getCheckInStatusUrl();
    const key = `CheckInService:POST:${url}:code=${encodeURIComponent(code ?? '')}`;

    return this.cache.getOrSet<CheckInStatusData>(
      key,
      HTTP_CACHE_TTL_MS.REGULAR,
      () => this.http.post<CheckInStatusResponse>(url, {code}).pipe(
        map(res => res.data)
      )
    );
  }

  getCheckIns(): Observable<Checkin[]> {
    const code = this.hoomvipStorage.getCode();
    const url = this.apiConfigService.getCheckinsUrl();
    const key = `CheckInService:POST:${url}:code=${encodeURIComponent(code ?? '')}`;

    return this.cache.getOrSet<Checkin[]>(
      key,
      HTTP_CACHE_TTL_MS.REGULAR,
      () => this.http.post<Checkin[]>(url, {code})
    );
  }

  getCheckInsWithChildren(): Observable<CheckInsWithChildren> {
    const code = this.hoomvipStorage.getCode();
    const url = this.apiConfigService.getCheckinsWithChildrenUrl();
    const key = `CheckInService:POST:${url}:code=${encodeURIComponent(code ?? '')}`;

    return this.cache.getOrSet<CheckInsWithChildren>(
      key,
      HTTP_CACHE_TTL_MS.REGULAR,
      () => this.http.post<CheckInsWithChildrenResponse>(url, {code}).pipe(
        map(res => res.checkins)
      )
    );

  }

  setCheckInAdult(setCheckInAdult: SetCheckInAdult) {
    this.cache.invalidate('CheckInService:');
    return this.http.post<CheckInAdultResponse>(this.apiConfigService.setCheckinUrl(), setCheckInAdult);
  }

  setCheckInMinor(setCheckInMinor: SetCheckInMinor) {
    this.cache.invalidate('CheckInService:');
    return this.http.post<CheckInMinorResponse>(this.apiConfigService.setCheckinMinorUrl(), setCheckInMinor);
  }
}
